import * as React from "react";
import { Flex, Spinner } from "@radix-ui/themes";
import { Authenticated, AuthLoading, Unauthenticated } from "convex/react";
import { SignIn } from "../auth/SignIn.tsx";
import { AuthShell } from "../auth/AuthShell.tsx";
import { Navigate } from "../common/Navigate.tsx";
import { routes } from "../routing/router.ts";

interface Props {}

export const RootPage: React.FC<Props> = ({}) => {
  return (
    <AuthShell intro="Somewhere to keep the things you mean to read and watch.">
      <Unauthenticated>
        <SignIn />
      </Unauthenticated>
      <Authenticated>
        <Navigate to={routes.stash()} />
        <Flex justify="center">
          <Spinner size={"3"} />
        </Flex>
      </Authenticated>
      <AuthLoading>
        <Flex justify="center">
          <Spinner size={"3"} />
        </Flex>
      </AuthLoading>
    </AuthShell>
  );
};
